export default __webpack_public_path__ + "static/media/06__o_preview_0.33bf7d36.jpg";